import { Axios, AxiosHeaders } from "axios";

import { authAxios } from "@/api/axios";

import type { IHlsLinkData } from "./hls_models";

class HlsApi {
  baseUrl?: string;
  headers?: AxiosHeaders;
  client: Axios;

  constructor({ baseUrl, headers }: { baseUrl?: string; headers?: AxiosHeaders }) {
    this.headers = headers;
    this.baseUrl = baseUrl;
    this.client = new Axios({
      baseURL: baseUrl,
      headers: headers,
      responseType: "json",
    });
  }

  async fetchHlsEncData(url: string): Promise<string> {
    return authAxios({
      url: url,
      method: "POST",
      headers: this.headers,
    }).then((res) => res.data);
  }

  async fetchLink(url: string): Promise<IHlsLinkData> {
    return authAxios({
      url: url,
      method: "GET",
      headers: this.headers,
    }).then((res) => res.data);
  }
}

export default HlsApi;
